import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StandardRelevanceService } from '../../service/standard-relevance.service';
import { StandardRelevanceActions } from './standard-relevance.actions';
import { MessageService } from 'primeng/api';


@Injectable()
export class StandardRelevanceEffects {

  loadStandardRelevances$ = createEffect(
    (rs: StandardRelevanceService = inject(StandardRelevanceService)) => {
      return this.actions$.pipe(

        ofType(StandardRelevanceActions.loadRelevance),
        mergeMap(({ parameters, size, typeOfBusines, valueChain, year, au }) =>
          rs.getStandardRelevance(size, typeOfBusines, valueChain, year, parameters, au).pipe(
            map((riskMap) => {
              return StandardRelevanceActions.loadRelevanceSuccess({
                riskMap
              });
            }),
            catchError((error) => of(StandardRelevanceActions.loadRelevanceFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadStandardRelevancesFilters$ = createEffect(
    (rs: StandardRelevanceService = inject(StandardRelevanceService)) => {
      return this.actions$.pipe(

        ofType(StandardRelevanceActions.loadRelevanceFilters),
        mergeMap(({ parameters, size, typeOfBusines, valueChain, year, au }) =>
          rs.getStandardRelevance(size, typeOfBusines, valueChain, year, parameters, au).pipe(
            map((riskMap) => {
              return StandardRelevanceActions.loadRelevanceFiltersSuccess({
                riskMap
              });
            }),
            catchError((error) => of(StandardRelevanceActions.loadRelevanceFiltersFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateRelevanceByIds$ = createEffect(
    (rs: StandardRelevanceService = inject(StandardRelevanceService)) => {
      return this.actions$.pipe(

        ofType(StandardRelevanceActions.updateRelevance),
        mergeMap(({ riskRelevanceTree }) =>
          rs.updateStandardRelevance(riskRelevanceTree).pipe(
            map((relevance) => {
              return StandardRelevanceActions.updateRelevanceSuccess({
                relevance
              });
            }),
            catchError((error) => of(StandardRelevanceActions.updateRelevanceFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getFilters$ = createEffect(
    (rs: StandardRelevanceService = inject(StandardRelevanceService)) => {
      return this.actions$.pipe(

        ofType(StandardRelevanceActions.loadAllRelevanceTree),
        mergeMap(({ au, size, typeOfBusiness, valueChain, year }) =>
          rs.getFilers(au, size, typeOfBusiness, valueChain, year).pipe(
            map((filters) => {
              return StandardRelevanceActions.loadAllRelevanceTreeSuccess({
                filters
              });
            }),
            catchError((error) => of(StandardRelevanceActions.loadAllRelevanceTreeFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  clearRelevance$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StandardRelevanceActions.clearRelevance)
      ),
    { functional: true, dispatch: false }
  );
  uploadExcel$ = createEffect(
    (rs: StandardRelevanceService = inject(StandardRelevanceService), messageService: MessageService = inject(MessageService)) => {
      return this.actions$.pipe(

        ofType(StandardRelevanceActions.uploadExcel),
        mergeMap(({ base64ExcelFile, parameters, size, typeOfBusines, valueChain, year, au }) =>
          rs.uploadExcel(base64ExcelFile)
            .pipe(
              map((res) => {

                messageService.add({ summary: res!.type!, detail: res!.message!, severity: res?.status ? 'success' : 'error', life: 86400000 })

                if (size && typeOfBusines && valueChain && year)
                  return StandardRelevanceActions.loadRelevance({
                    parameters,
                    size,
                    typeOfBusines,
                    valueChain,
                    year,
                    au
                  })
                else
                  return StandardRelevanceActions.uploadExcelSuccess({
                    res
                  });
              }),
              catchError((error) => of(StandardRelevanceActions.uploadExcelFailure({ error })))
            )
        )
      );
    },
    { functional: true }
  );

  downloadStandardRelevance$ = createEffect(() => {
    const as = inject(StandardRelevanceService);
    return this.actions$.pipe(
      ofType(StandardRelevanceActions.downloadStandardRelevance),
      mergeMap(({ parameters, timeZone, year, size, typeOfBusines, valueChain }) => {
        return as.downloadStandardRelevance(parameters, timeZone, Number(year), valueChain as string, typeOfBusines as string, size as string).pipe(
          map((res) => {
            if (res?.length > 0) {
              this.downloadFile(res[0].content, res[0].filename);
            } else {
              console.error("Dati non validi:", res);
            }
            return StandardRelevanceActions.downloadStandardRelevanceSuccess({
              export: res
            });
          }),
          catchError((error) => {
            console.error("Errore durante il download:", error);
            return of(StandardRelevanceActions.downloadStandardRelevanceFailure({ error }));
          })
        );
      })
    );
  });


  async downloadFile(response: string, fileName: string | undefined) {
    const typeFormat = {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
    const link = window.document.createElement("a");
    const blob = this.base64ToBlob(response, typeFormat.type);
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName ?? "fileExport";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }

  constructor(private actions$: Actions) { }
}
